module.exports = __webpack_public_path__ + "img/addplus.f1dcd88b.png";